<style lang="less" scoped>
  .content {
    padding-top: 32px;
    align-items: start;
  }
</style>

<template lang="pug">
  .result.std-layout
    .header
      header-component(
        @click-home='redirectHome'
        @click-restart='restart')
    .content
      scoreboard-component(
        :score='score'
        :usedTime='usedTime'
        :mode='mode'
        :game='game'
        :bestScore='bestScore'
        :bestTime='bestTime')
</template>

<script>
import HeaderComponent from '@/components/header/home_restart';
import ScoreboardComponent from '@/components/scoreboard';
import GameType from '@/game';

export default {
  computed: {
    mode() {
      return this.$store.state.app.mode;
    },
    game() {
      return this.$store.state.app.game;
    },
    gameName() {
      let name = '';
      switch (this.game) {
        case GameType.game.number:
          name = '숫자 게임';
          break;
        case GameType.game.card:
          name = '카드 게임';
          break;
        case GameType.game.image:
          name = '이미지 게임';
          break;
        default:
          name = '게임';
      }
      return name;
    },
    score() {
      return this.$store.state.app.score;
    },
    usedTime() {
      return this.$store.state.app.usedTime;
    },
    bestScore() {
      return this.$store.state.app.bestScore;
    },
    bestTime() {
      return this.$store.state.app.bestTime;
    },
  },
  methods: {
    redirectHome() {
      this.$router.push('/');
    },
    restart() {
      // Restart
      let url = '';
      switch (this.mode) {
        case GameType.mode.time:
          url += '/time';
          break;
        case GameType.mode.training:
          url += '/training';
          break;
        default:
          url = '/';
      }
      switch (this.game) {
        case GameType.game.card:
          url += '/card';
          break;
        case GameType.game.image:
          url += '/image';
          break;
        case GameType.game.number:
          url += '/number';
          break;
        default:
          url = '/';
      }
      this.$router.replace(url);
    },
  },
  components: {
    HeaderComponent,
    ScoreboardComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/result.vue